<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Specialist from "@/models/specialist.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Specialist.getSchema(),
			};
		},
		methods: {
			openEntity(user) {
				this.$router.push(`/especialista/${user.id}`);
			},
			createEntity() {
				this.$router.push(`/especialista/novo`);
			},
			searchEntities(paginationParameters) {
				const searchParameters = Object.assign({
					role: "SPECIALIST",
				}, paginationParameters);
				return Specialist.search(searchParameters);
			},
		},
	}
</script>
